module.exports = __webpack_public_path__ + "static/media/matte2.9e4a270b.jpg";